module.exports = __webpack_public_path__ + "static/media/WBlogo.1bcd4bd5.svg";